import React, { useEffect, useRef } from "react";
import { Modal } from "antd";

let scriptPromise;
const loadTurnstile = () => {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error("Security check unavailable."));
      script.onerror = () => { script.remove(); reject(new Error("Security check unavailable. Please try again.")); };
      document.head.appendChild(script);
    }).catch((error) => { scriptPromise = null; throw error; });
  }
  return scriptPromise;
};

const Challenge = ({ challenge, onToken, onError }) => {
  const container = useRef(null);
  useEffect(() => {
    let cancelled = false;
    let widget;
    loadTurnstile().then((turnstile) => {
      if (cancelled) return;
      widget = turnstile.render(container.current, {
        sitekey: challenge.site_key, action: challenge.action, cData: challenge.cdata,
        callback: onToken,
        "error-callback": () => onError(new Error("Security check failed. Please try again.")),
        "expired-callback": () => onError(new Error("Security check expired. Please try again.")),
      });
    }).catch(onError);
    return () => { cancelled = true; if (widget !== undefined && window.turnstile) window.turnstile.remove(widget); };
  }, [challenge, onToken, onError]);
  return <div ref={container} aria-label="Image upload security check" />;
};

export const solveImageChallenge = (challenge) => new Promise((resolve, reject) => {
  let dialog;
  let finished = false;
  const finish = (error, token) => {
    if (finished) return;
    finished = true;
    clearTimeout(timeout);
    if (dialog) dialog.destroy();
    if (error) reject(error); else resolve(token);
  };
  const timeout = setTimeout(() => finish(new Error("Security check timed out. Please try again.")), 120000);
  dialog = Modal.confirm({
    title: "Quick security check",
    content: <Challenge challenge={challenge} onToken={(token) => finish(null, token)} onError={finish} />,
    okButtonProps: { style: { display: "none" } },
    cancelText: "Cancel",
    onCancel: () => finish(new Error("Complete the security check before uploading more images.")),
  });
});
